module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("设置" + _vm._s(_vm.characterToDisplay))])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('span', {
    staticClass: "currentReconciler"
  }, [_vm._v("当前" + _vm._s(_vm.characterToDisplay))]), _vm._v(" "), _c('div', {
    staticClass: "avatorWrap"
  }, [_c('img', {
    staticClass: "avator",
    attrs: {
      "src": "/static/img/avator2.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "liuChengbiao"
  }, [_vm._v(_vm._s(_vm.characterNameToDisplay))])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "research-background-color open-popup open-researchGroupMember",
    class: _vm.character === 'horMember' ? 'tagWrap2' : 'tagWrap',
    attrs: {
      "data-popup": ".popup-researchGroupMember"
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("更换" + _vm._s(_vm.characterToDisplay))])])])])]), _vm._v(" "), (_vm.showResearchGroupRemindBox) ? _c('ResearchGroupRemindBox', {
    attrs: {
      "remindParams": _vm.remindParams
    },
    on: {
      "toggleShow": _vm.toggleResearchGroupRemindBox
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cabd1ef","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchMemberManagement/ResearchMemberCharacterSetting.vue
// module id = 1625
// module chunks = 8